// eslint-disable-next-line import/prefer-default-export
export const getServiceStatusState = (state) => state.serviceStatus;
